import { render } from "./CompanyStaff.vue?vue&type=template&id=6902b748"
import script from "./CompanyStaff.vue?vue&type=script&lang=js"
export * from "./CompanyStaff.vue?vue&type=script&lang=js"
script.render = render

export default script